import _ from '@bingads-webui-component-legacy/extension/underscore';
import ko from 'knockout';
import ObjectListInput from '@bingads-webui-component-legacy/object-list-input/view/index';
import TableRowView from '@bingads-webui-campaign-legacy/adextension-price/view/tablerow';
// import { convertCurrencyCode } from '@bingads-webui-campaign-legacy/adextension-price/utility';
import headerTemplate from '@bingads-webui-campaign-legacy/adextension-price/template/tableRowHeaderTemplate.pug';
import { isValidUrl } from '@bingads-webui/url-util';

const s$i18n = window.globalLegacyI18n.get('$/schema-i18n!campaign');
const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

function convertUrl(url) {
  if (_.isEmpty(url) || (/(^(http|https):\/\/.*)|^$/).test(url)) {
    return url;
  }
  return `http://${url}`;
}

export default class View extends ObjectListInput {
  get className() {
    return 'price-extension-table-rows';
  }

  initialize({observable}) {
    let opt = {
      minItems: 3,
      maxItems: 8,
      View: TableRowView,
      headerTemplate: headerTemplate({
        s$i18n,
      }),
      values: this.convertObservable(observable),
    };

    super.initialize(opt);

    let values = ko.computed(() => {
      return _.map(this.koModel.objects(), (obj) => {
        const ret = obj.viewModel.toObject();

        ret.FinalUrls = _.isEmpty(ret.FinalUrls) ? [] : [convertUrl(ret.FinalUrls)];
        ret.FinalMobileUrls = _.isEmpty(ret.FinalMobileUrls) ? [] : [convertUrl(ret.FinalMobileUrls)];
        // ret.CurrencyCode = viewModel.CurrencyCode();  // eslint-disable-line new-cap

        // obj.viewModel.CurrencyCode(convertCurrencyCode(ret.CurrencyCode)); // eslint-disable-line new-cap

        return ret;
      });
    });

    values.subscribe((newValue) => {
      observable(newValue);
    });

    // viewModel.CurrencyCode.subscribe((newValue) => {
    //   _.each(this.koModel.objects(), (obj) => {
    //     obj.viewModel.CurrencyCode(convertCurrencyCode(newValue));  // eslint-disable-line new-cap
    //   });
    // });

    observable.validate = () => {
      const rowList = this.koModel.objects();
      const noInvalidRow = _.every(rowList, (row) => row.validate());

      let headerMap = {};
      let urlValid = true;

      _.each(rowList, (row, index) => {
        const obj = row.viewModel.toObject();

        if (_.isEmpty(obj.Header)) {
          return;
        }

        if (_.has(headerMap, obj.Header)) {
          headerMap[obj.Header].push(index);
        } else {
          headerMap[obj.Header] = [index];
        }

        // check if Header same to Description
        if (obj.Header.trim() === obj.Description.trim()) {
          row.setErrors({
            Header: [i18n.get('PriceAdExtensions_TableRow_Header_Description_Duplicated')],
            Description: [i18n.get('PriceAdExtensions_TableRow_Header_Description_Duplicated')],
          });
        }

        if (!isValidUrl(convertUrl(obj.FinalUrls))) {
          row.setErrors({
            FinalUrls: [i18n.get('Error_Campaign_API_InvalidUrl')],
          });
          urlValid = false;
        }

        if (obj.FinalMobileUrls && !isValidUrl(convertUrl(obj.FinalMobileUrls))) {
          row.setErrors({
            FinalMobileUrls: [i18n.get('Error_Campaign_API_InvalidUrl')],
          });
          urlValid = false;
        }
      });

      const dups = _.chain(headerMap).values().filter((arr) => _.size(arr) > 1).value();

      _.each(_.flatten(dups), (val) => {
        rowList[val].setErrors({ Header: [i18n.get('PriceAdExtensions_TableRow_Duplicate_Header')] });
      });

      return noInvalidRow && _.size(dups) === 0 && urlValid;
    };
  }

  convertObservable(observable) {
    _.each(observable(), (item) => {
      delete item.PriceInfo;
    });

    let values = _.deepClone(observable());

    // if (_.isEmpty(values)) {
    //   const currencyCode = viewModel.CurrencyCode(); // eslint-disable-line new-cap

    //   values = [{
    //     CurrencyCode: currencyCode,
    //   }, {
    //     CurrencyCode: currencyCode,
    //   }, {
    //     CurrencyCode: currencyCode,
    //   }];
    //   return values;
    // }

    // viewModel.CurrencyCode(values[0].CurrencyCode); // eslint-disable-line new-cap

    _.each(values, (value) => {
      value.FinalUrls = _.first(value.FinalUrls);
      value.FinalMobileUrls = _.first(value.FinalMobileUrls);
      // value.CurrencyCode = convertCurrencyCode(value.CurrencyCode);
    });

    return values;
  }

}
